define(
    'viewmodels/secured/explorer/details/tabs/actions/ExportDocumentsAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, dialogService, documentsService, i19n) {

        var CopyDocumentsAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.exportdetails,
                    message: i19n.to.exportdocumentdetailstoexcel
                },
                dialogoptions: {
                    ok: {
                        label: i19n.to.export,
                        message: ''
                    },
                    cancel: {
                        label: i19n.to.cancel,
                        message: ''
                    }
                }
            };

            __extends(_Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-table", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();                               
                
                documentsService.actions.canExportDocuments(documents)
                .done(function (result) {                    
                    var promise;

                    if (!result.success) {
                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal", [result]);
                    } else {
                        promise = dialogService.showMessageBox(String.format(i19n.to._documentsselectedfordetailexport, documents.length),i19n.to.wouldyouliketoexportdetailsforthedocument,_.toArray(_i19n.dialogoptions));

                        promise.then(function (dialogResult) {
                            if (dialogResult == _i19n.dialogoptions.ok) {
                                var grid = $("#results-grid").data("kendoGrid");
                                var $rows = grid.tbody.find('tr').filter(':has(input:checkbox[class="checkbox-action-results-grid"]:checked)');

                                //#region export init
                                var columns = [];
                                var rows = [];

                                _.map(grid.columns, function (itm) {
                                    if (!itm.hidden
                                        && itm.field != "checked"
                                        && itm.field != "icon") {
                                        columns.push(itm);
                                    }
                                });

                                var data = { cells: [] };
                                _.map(columns, function (col) {
                                    data.cells.push({ value: col.title });
                                });

                                rows.push(data);

                                for (var i = 0; i < $rows.length; i++) {
                                    var row = grid.dataItem($($rows[i]));

                                    var data = { cells : [] };
                                    _.map(columns, function (col) {
                                        var val = row[col.field];

                                        if (col.field == "documentClass") {
                                            if (val == "0" || val === undefined) val = "Working";
                                            if (val == "1") val = "Email";
                                            if (val == "2") val = "Controlled";
                                        }
                                        
                                        if (col.isDate)
                                            val = kendo.toString(val, 'd') != kendo.toString(new Date('0001-01-01T00:00:00+00:00'), 'd') ? val : "";
                                        
                                        data.cells.push({ value: val });
                                    });
                                    
                                    rows.push(data);
                                }

                                //#endregion

                                documentsService.actions.exportDocumentsXLS(rows, "Doc Details Export " + kendo.toString(new Date(), "yyyy-MM-dd HH-mm"));
                            }
                        });
                    }

                    promise.always(complete);
                });
            }
 
            return _Action;

        })(Action);

        return CopyDocumentsAction;
        
    });
